export interface IStaffResponse {
    manager: IStaffObject[];
  }
  
  export interface IStaffObject {
    emailAddress: string;
    enabled: string;
    firstName: string;
    gender: string;
    isAdmin: string;
    lastName: string;
    preferredLanguage: string;
    preferredUnit: string;
    soleManager: string;
    thumbnailUrl: string;
    userId: string;
    userRights: userPermissions;
    userType: string;
  }
  
  export class staffDetails {
    facilityId: string;
    email: string;
    isAdmin: string;
    userRights: userPermissions;
    isOptedIn: string;
    constructor(_facilityId: string, _email: string, _isAdmin: string, _userRights: userPermissions, _isOptedIn: string) {
      this.facilityId = _facilityId;
      this.email = _email;
      this.isAdmin = _isAdmin;
      this.userRights = _userRights;
      this.isOptedIn = _isOptedIn;
    }
  }
  export class permissionChanges {
    target: targetValue;
  }
  export class targetValue {
    id: string;
    value: string;
  }
  
  export class allStaffPermissions {
    header: string;
    displayPermission: string;
    showIfAdmin?: string;
    permission: staffPermission[];
    constructor(
      _header: string,
      _displayPermission: string,
      _showIfAdmin: string = 'false',
      _permission: staffPermission[]
    ) {
      this.header = _header;
      this.displayPermission = _displayPermission;
      this.showIfAdmin = _showIfAdmin;
      this.permission = _permission;
    }
  }
  export class staffPermission {
    name: string;
    title: string;
    content: string;
    isLearnMore?: boolean;
    learnMoreContent: string;
    learnMoreURL: string;
    showPermission: string;
    type: string;
    alwaysShow?: string;
    isNew: boolean;
    menuPermissions: menuPermission;
    ownAccount: boolean;
  
    constructor(
      _name: string,
      _title: string,
      _content: string,
      _isLearnMore: boolean = false,
      _learnMoreContent: string,
      _learnMoreURL: string,
      _showPermission: string,
      _type: string,
      _alwaysShow: string,
      _isNew: boolean = false,
      _menuPermissions: menuPermission,
      _ownAccount: boolean
    ) {
      this.name = _name;
      this.title = _title;
      this.content = _content;
      this.isLearnMore = _isLearnMore;
      this.learnMoreContent = _learnMoreContent;
      this.learnMoreURL = _learnMoreURL;
      this.showPermission = _showPermission;
      this.type = _type;
      this.alwaysShow = _alwaysShow;
      this.isNew = _isNew;
      this.menuPermissions = _menuPermissions;
      this.ownAccount = _ownAccount;
    }
  }
  export interface menuPermission {
    F: string;
    V: string;
    H: string;
  }
  export interface userPermissions {
    [x: string]: any;
    branding: string;
    calendar: string;
    customize: string;
    disconnectNotification: string;
    facility: string;
    facilityStaff: string;
    membersChallenges: string;
    membersManage: string;
    membersPromote: string;
    membersRetention: string;
    serviceNotice: string;
    software: string;
    stats: string;
    trainingChallenges: string;
    trainingClasses: string;
    trainingPrograms: string;
    lfodEnabledEquipment: string;
    digitalCoach: string;
  }
  
  export interface permissionButton {
    id: string;
    permission?: boolean;
    type: boolean;
    value: string;
    text: string;
    class: string;
  }
  export interface staffActions {
    data: IStaffObject;
    action: string;
    navigationId: number;
  }
  export interface staffInfo {
    fullName: string;
    email: string;
    profilePic: string;
    userId: string;
    isAdmin: string;
  }
